import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Observable, of, tap } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { HttpService } from "../http.service";
import { ReturnOrder, ReturnOrderResponse } from "../../../models/admin/orders.model";
import { cancelInput, OrderListResponse, requestReturn, returnApproveRequest, SubmitResponse } from "@sgm-frontend/core";


@Injectable({
    providedIn: 'root'
})
export class OrdersReturnService extends HttpService<any | cancelInput | returnApproveRequest, ReturnOrderResponse> {

    private returnListSubject = new BehaviorSubject<ReturnOrderResponse | null>(null);
    readonly returnList$ = this.returnListSubject.asObservable();
    constructor(
        httpClient: HttpClient,
        @Inject('API_URL') apiUrl: string,
        @Inject('API_VERSION') apiVersion: string
    ) {
        super(httpClient, apiUrl, apiVersion, 'orders/return');
    }


    // return

    getAllReturnRequests(page = 1, limit = 10): Observable<ReturnOrderResponse | null> {
        return this.getPagedGeneral('orders/return', page, limit).pipe(
            tap(response => this.returnListSubject.next(response)),
            catchError(() => of(null))
        );
    }
    getFilteredReturnRequests(entity: any): Observable<ReturnOrderResponse | null> {
        return this.filterReturnActionPaged(entity, 'admin').pipe(
            tap((response) => this.returnListSubject.next(response)),
            catchError(() => of(null))
        );
    }
    deleteRequestByOrderId(orderId: string): Observable<SubmitResponse> {
        return this.delete(orderId);
    }
    getReturnOrderByOrderId(orderId: string): Observable<ReturnOrder> {
        return this.getById(orderId + '/admin').pipe(catchError((error) => of(error)));
    }
    approveReturnByOrderId(request: returnApproveRequest): Observable<ReturnOrder> {
        return this.update(request, 'request/approve').pipe(catchError((error) => of(error)));
    }
    rejectReturnByid(request: returnApproveRequest): Observable<ReturnOrder> {
        return this.update(request, 'request/reject').pipe(catchError((error) => of(error)));
    }
    approveRefundByOrderId(request: returnApproveRequest): Observable<ReturnOrder> {
        return this.update(request, 'refund/approve').pipe(catchError((error) => of(error)));
    }
    rejectReturnRefundByid(request: returnApproveRequest): Observable<ReturnOrder> {
        return this.update(request, 'refund/reject').pipe(catchError((error) => of(error)));
    }
    returnRequest(request: requestReturn): Observable<SubmitResponse> {
        return this.create(request, 'request/admin').pipe(catchError((error) => of(error)));
    }
     downloadReturnOrders(params: any): Observable<Blob> {
        return this.downloadFileWithParams('orders/return/export', params);
    }
}